module.exports = __webpack_public_path__ + "static/media/icon-cancel.cc9c5f95.svg";